import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./assets/css/main.css";

ReactDOM.render(<App />, document.getElementById("root"));
